<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bJoaZ5/tc-custom/9781426814433.jpg?1726617382427" alt="This image is the cover for the book Frontier Courtship"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Frontier Courtship
      </h1>
      <p class="bookDescription body article font2">
        <b>A Journey of Hope </b><br/><br/>She had made a solemn promise to see her younger sister to safety in California. But the endless journey across the frontier was proving to be a heartbreaking test of courage and endurance for Faith Beal. All she had to sustain her was her steadfast belief in a loving Godand the guiding hand of a stranger who truly seemed heaven-sent. <br/><br/><b>and Love </b><br/><br/>Connell McClain was her selfless guardian as their wagon train slowly made its way West. And as they shared the dangers of the trailand the closeness of a covered wagonFaith felt the first tender stirrings of love for this rough-hewn yet caring man. But would the secrets that seemed to haunt him threaten their growing feelings for one another?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Valerie Hansen
      </h2>
      
      <p class="authorDescription body article">Valerie Hansen resides in&#160;the rural Ozarks where she&#160;writes the books of her heart, primarily&#160;for Love Inspired Romance and Suspense. She is married to her childhood sweetheart and&#160;has worked as a teacher&#39;s-aide, EMT, fire dept. dispatcher, dog breeder, commercial artist,&#160;dulcimer builder, Veterinarian&#39;s&#160;asst.,&#160;4-H leader, Sunday School teacher, antique restorer and certified Storm Spotter, etc. See ValerieHansen.com for more!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59b1ceb2